// src/Dashboard/pages/user/Absences/components/SelectedAdherentCard.jsx

import React from "react";
import { FaCheckCircle, FaUserClock } from "react-icons/fa";

import { DEFAULT_USER_PHOTO } from "../constants/absenceConstants";
import {
  getAbsenceStatus,
  getAdherentName,
  isAdherentAbsent,
  toAbsolutePhotoUrl,
} from "../utils/absenceUtils";

import StatusBadge from "./StatusBadge";

export default function SelectedAdherentCard({
  adherent,
  onMarkReturned,
  busy,
}) {
  if (!adherent) {
    return (
      <div className="rounded-[1.5rem] border border-dashed border-slate-300 bg-slate-50 p-5 text-center dark:border-slate-700 dark:bg-slate-900/60">
        <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-2xl bg-white text-slate-400 shadow-sm dark:bg-slate-950">
          <FaUserClock className="text-xl" />
        </div>

        <p className="mt-3 text-sm font-bold text-slate-800 dark:text-slate-100">
          Sélectionnez un adhérent
        </p>

        <p className="mt-1 text-xs leading-5 text-slate-500 dark:text-slate-400">
          Son statut actuel s’affichera ici avec les actions disponibles.
        </p>
      </div>
    );
  }

  const status = getAbsenceStatus(adherent);
  const StatusIcon = status.icon;
  const canMarkReturned = isAdherentAbsent(adherent);

  return (
    <div
      className={`overflow-hidden rounded-[1.5rem] border p-4 shadow-sm ${status.card}`}
    >
      <div className="flex items-start gap-4">
        <img
          src={toAbsolutePhotoUrl(adherent.photo_url) || DEFAULT_USER_PHOTO}
          alt={getAdherentName(adherent)}
          className="h-16 w-16 shrink-0 rounded-2xl object-cover ring-1 ring-slate-200 dark:ring-slate-700"
          onError={(event) => {
            event.currentTarget.src = DEFAULT_USER_PHOTO;
          }}
        />

        <div className="min-w-0 flex-1">
          <p className="truncate text-base font-bold text-slate-950 dark:text-white">
            {getAdherentName(adherent)}
          </p>

          <div className="mt-2">
            <StatusBadge adherent={adherent} />
          </div>

          <p className="mt-2 flex items-center gap-2 text-xs leading-5 text-slate-600 dark:text-slate-300">
            <StatusIcon className="shrink-0" />
            {status.description}
          </p>
        </div>
      </div>

      {adherent.notes_adherent && (
        <div className="mt-4 rounded-2xl bg-white/70 p-3 text-xs leading-5 text-slate-600 ring-1 ring-slate-200 dark:bg-slate-950/60 dark:text-slate-300 dark:ring-slate-700">
          <span className="font-bold text-slate-800 dark:text-slate-100">
            Dernières notes :
          </span>{" "}
          <span className="line-clamp-3">{adherent.notes_adherent}</span>
        </div>
      )}

      <button
        type="button"
        onClick={onMarkReturned}
        disabled={!canMarkReturned || busy}
        className="mt-4 inline-flex min-h-12 w-full items-center justify-center gap-2 rounded-2xl bg-emerald-600 px-4 text-sm font-bold text-white shadow-lg shadow-emerald-200/60 transition hover:-translate-y-0.5 hover:bg-emerald-700 disabled:cursor-not-allowed disabled:opacity-50 dark:shadow-black/20"
      >
        <FaCheckCircle />
        {busy ? "Enregistrement…" : "Marquer comme repris"}
      </button>
    </div>
  );
}